import { init as initKwikPass } from './fineri-kwikpass.js';
import { init as initCartDrawer } from './fineri-cart-drawer.js';
import { init as initCart } from './fineri-cart.js';
import { init as initFilters } from './fineri-filters.js';
import { init as initPredictiveSearch } from './fineri-predictive-search.js';
import { init as initQuickView } from './fineri-quick-view.js';
import { init as initPdpSections } from './fineri-pdp-sections.js';
import { init as initNavigation } from './fineri-navigation.js';
import { init as initHeaderDrawer } from './fineri-header-drawer.js';
import { initSubheaderMega } from './fineri-subheader-mega.js';
import { initMotion } from './fineri-motion.js';
import { init as initCartPage } from './fineri-cart-page.js';
import { initToastBridge } from './fineri-toast.js';
import { initBackToTop } from './fineri-back-top.js';
import { initWishlistPage } from './fineri-wishlist.js';
import { initPlpFilterUi } from './fineri-plp-filters.js';

function hasSelector(sel) {
  return Boolean(document.querySelector(sel));
}

function bodyHasClass(prefix) {
  return document.body.className.split(/\s+/).some((c) => c === prefix || c.startsWith(prefix));
}

function boot() {
  initKwikPass();
  initHeaderDrawer();
  initPlpFilterUi();
  initNavigation(document);
  initSubheaderMega(document);
  initMotion(document);
  initCartDrawer();
  initCart();
  initToastBridge();
  initBackToTop();

  if (hasSelector('[data-fineri-plp-root]') || hasSelector('[data-fineri-search-root]')) {
    initFilters();
  }

  if (hasSelector('.fineri-header__search-input')) {
    initPredictiveSearch();
  }

  if (
    hasSelector('[data-fineri-quick-view]') ||
    hasSelector('[data-fineri-card-gallery]')
  ) {
    initQuickView();
  }

  if (bodyHasClass('template-product') || hasSelector('[data-fineri-pdp-refresh-sections]')) {
    initPdpSections();
  }

  if (bodyHasClass('template-cart') || hasSelector('[data-fineri-cart-page-root]')) {
    initCartPage();
  }

  if (hasSelector('[data-fineri-wishlist-page]')) {
    initWishlistPage();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

